import { arrayOf, bool, element, eventListener, intellisense, IntellisenseExpectedType, object, oneOfType, string } from '@philips-internal/oswald-ui-core/prop-types';
import { SKIP_FETCH_SYMBOL } from './fetch-symbol.js';
const FetchProperties = {
    children: {
        type: oneOfType([element, arrayOf(element)]).notEnumerable(),
    },
    dependeeData: {
        type: object.notEnumerable(),
    },
    endpoint: {
        defaultValue: '',
        type: intellisense(string, IntellisenseExpectedType.URL),
    },
    lazy: {
        type: bool,
    },
    onAbort: {
        type: eventListener,
    },
    onAfterFetch: {
        type: eventListener,
    },
    onBeforeFetch: {
        type: eventListener,
    },
    parameters: {
        type: object.notEnumerable(),
    },
    reset: {
        type: bool.notEnumerable(),
    },
    totalCountHeader: {
        defaultValue: 'X-Total-Count',
        type: string,
    },
    uuid: {
        type: string,
    },
};
export { FetchProperties, };
//# sourceMappingURL=fetch-types.js.map